<script>
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import moment from 'moment'
import { cloneDeep, isMatch, find } from 'lodash'
export default {
  getMessage: field => `Giá trị của ${field} đã bị trùng trong bảng, vui lòng chọn giá trị không trùng`,
  validate (value, { runRule, fieldName, dataType, config, rootModel } = {}) {
    if (runRule) {
      if (dataType === 'timestamps') {
        value = typeof value === 'object' ? cloneDeep(value) : cloneDeep(firebase.firestore.Timestamp.fromDate(moment(value, config.format).toDate()))
      }
      if (rootModel instanceof Object) {
        for (let index in rootModel) {
          let finded = find(rootModel[index], item => isMatch(item[fieldName], value))
          if (finded) {
            return false
          }
        }
      } else if (rootModel instanceof Array) {
        return !find(rootModel, item => isMatch(value, item[fieldName]))
      }
    }
    return true
  }
}
</script>
